import React from 'react'

// Renders a policy rule's plain-text content as lightly-formatted, SAFE React
// nodes: blank-line-separated paragraphs, single newlines as <br>, and
// consecutive bullet/numbered lines as a list. No HTML is interpreted — React
// escapes every text node — so this is XSS-safe even though rule content is
// AI-extracted from an uploaded PDF.
const BULLET = /^\s*([-*•]|\d+[.)])\s+(.*)$/

const renderRuleContent = (text) => {
  if (!text) return null

  const blocks = text.replace(/\r\n/g, '\n').split(/\n{2,}/)
  return blocks.map((block, bi) => {
    const lines = block.split('\n')
    const allBullets = lines.length > 0 && lines.every((l) => BULLET.test(l))

    if (allBullets) {
      return (
        <ul key={bi} className="small mb-2 ps-3">
          {lines.map((l, li) => <li key={li}>{l.match(BULLET)[2]}</li>)}
        </ul>
      )
    }

    return (
      <p key={bi} className="small mb-2" style={{ whiteSpace: 'pre-wrap' }}>
        {lines.map((l, li) => (
          <React.Fragment key={li}>
            {li > 0 && <br />}
            {l}
          </React.Fragment>
        ))}
      </p>
    )
  })
}

export default renderRuleContent
